/*
 *
 * ReminderEmails actions
 *
 */

import {
  GET_CONFIGURATION_WATCHER,
  GET_CONFIGURATION_SUCCESS,
  GET_CONFIGURATION_FAILED,
  PUT_CONFIGURATION_WATCHER,
  PUT_CONFIGURATION_SUCCESS,
  PUT_CONFIGURATION_FAILED,
} from "./constants"

// UPDATE CONFIGURATION
export function putConfigurationWatcher(payload) {
  return {
    type: PUT_CONFIGURATION_WATCHER,
    payload,
  }
}

export function putConfigurationSuccess(payload) {
  return {
    type: PUT_CONFIGURATION_SUCCESS,
    payload,
  }
}

export function putConfigurationFailed(payload) {
  return {
    type: PUT_CONFIGURATION_FAILED,
    payload,
  }
}

// GET CONFIGURATION
export function getConfigurationWatcher(payload) {
  return {
    type: GET_CONFIGURATION_WATCHER,
    payload,
  }
}

export function getConfigurationSuccess(payload) {
  return {
    type: GET_CONFIGURATION_SUCCESS,
    payload,
  }
}

export function getConfigurationFailed(payload) {
  return {
    type: GET_CONFIGURATION_FAILED,
    payload,
  }
}
